import React from 'react';
import { Shield, TrendingUp, Lock, AlertCircle, Globe, Award, Users, Building } from 'lucide-react';
import { Link } from 'react-router-dom';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: Shield,
      title: 'Legal Protection',
      description: 'Exclusive rights to use your mark nationwide and legal grounds to prevent others from using confusingly similar marks'
    },
    {
      icon: TrendingUp,
      title: 'Brand Equity',
      description: 'Build valuable brand recognition and customer loyalty that translates into tangible business value and market position'
    },
    {
      icon: Lock,
      title: 'Asset Value',
      description: 'Trademarks are intangible assets that can be licensed, sold, or used as collateral, adding significant value to your business'
    },
    {
      icon: AlertCircle,
      title: 'Legal Presumption',
      description: 'Federal registration provides legal presumption of ownership and validity, making enforcement much easier'
    },
    {
      icon: Globe,
      title: 'National Coverage',
      description: 'Exclusive rights across all 50 states, not just the areas where you currently do business'
    },
    {
      icon: Award,
      title: 'Competitive Edge',
      description: 'Stand out in crowded markets and establish a unique identity that competitors cannot legally replicate'
    },
    {
      icon: Users,
      title: 'Customer Trust',
      description: 'Build consumer confidence and recognition with a registered mark that signals quality and authenticity'
    },
    {
      icon: Building,
      title: 'Business Growth',
      description: 'Facilitate expansion, franchising, and licensing opportunities with a protected and established brand'
    }
  ];

  return (
    <section className="py-20 bg-white" aria-labelledby="benefits-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Powerful Advantages
          </div>
          <h2 id="benefits-heading" className="text-4xl md:text-5xl font-bold text-black mb-6">
            Benefits of Trademark Registration
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Registering your trademark provides comprehensive protection and opens doors to opportunities that unregistered marks simply cannot access
          </p>
        </div>

        {/* Benefits Grid - Horizontal scroll on mobile */}
        <div className="lg:grid lg:grid-cols-4 md:grid md:grid-cols-2 gap-8 hidden md:grid">
          {/* Desktop Grid */}
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B35] to-[#FF8C42] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <benefit.icon className="w-7 h-7 text-white" />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-black mb-3 group-hover:text-[#FF6B35] transition-colors">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>

              {/* Decorative element */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-[#FF6B35]/5 rounded-full blur-2xl group-hover:bg-[#FF6B35]/10 transition-all duration-300"></div>
            </div>
          ))}
        </div>

        {/* Mobile Horizontal Scroll */}
        <div className="md:hidden overflow-x-auto pb-4 -mx-4 px-4">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 shadow-lg border border-gray-100 flex-shrink-0"
                style={{ width: '280px' }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B35] to-[#FF8C42] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                  <benefit.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-black mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;